import Vue from "vue";
import Component from "vue-class-component";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate", // for vue-router 2.2+
]);
import Router from "vue-router";

// ROUTES
const Home = () => import("@/core/home.vue");

const Core = () => import("@/core/core.vue");
const RGPD = () => import("@/shared/components/RGPD.vue");

const GameESG = () => import("@/products/esg/game/game-esg.vue");
const Game360 = () => import("@/products/360/game/game360.vue");

const Conversational = () => import("@/products/modulable/game/conversational.vue");
const Onboarding = () => import("@/products/onboarding/onboarding.vue");

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: "history",
  routes: [
    { path: "/", component: Home },
    { path: "/core", component: Core },
    { path: "/core/:action", component: Core },
    { path: "/core/:action/:id", component: Core },

    { path: "/politics", name: "Page de RGPD", component: RGPD },

    //ODO ESG
    { path: "/esg/:origin/:gameId", name: "Questionnaire OdonaESG", component: GameESG },

    //ODO 360
    { path: "/360/:origin/:gameId", name: "Questionnaire Odona360", component: Game360 },
    { path: "/360/:origin/:gameId/:sequence", name: "Questionnaire Odona360 Facettes", component: Game360 },

    // ODOPRO
    { path: "/elearning/self-assessment/:gameId", name: "Auto-évaluation OdonaLEA", component: Game360 },

    // MODULABLE
    {
      path: "/conversational/:type/:origin/:sequence/:gameId",
      name: "Questionnaire conversationnel",
      component: Conversational,
    },
    {
      path: "/conversational/:type/:origin/:sequence/:gameId/:lang",
      name: "Questionnaire conversationnel",
      component: Conversational,
    },
    { path: "/onboarding/:type/:origin/:sequence/:gameId", name: "Onboarding", component: Onboarding },
  ],
});
